import {
  FETCH_AFFILIATE_DASHBOARD,
  FETCH_AFFILIATE_DASHBOARD_SIX_MONTH,
  FETCH_AFFILIATE_DASHBOARD_DATA,
  FETCH_AFFILIATE_RESERVATIONS,
  FETCH_AFFILIATE_DASHBOARD_INIT,
  TOAST,
} from "../../../types/affiliateDashboard.type";

const INITIAL_STATE = {
  dashboardData: null,
  totalAffiliates: 0,
  activeAffiliates: 0,
  affiliateMetrics: [],
  sixMonthMetrics: [],
  isSixMonthLoading: false,
  performanceMetrics: [],
  performancePaginationInfo: null,
  isPerformanceLoading: false,
  affiliateReservations: {},
  isLoadingReservations: {},
  isLoading: false,
  isLoadingPage: true,
  error: null,
  isPageLevelError: false,
};

export const affiliateDashboardReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_AFFILIATE_DASHBOARD_INIT:
      return {
        ...INITIAL_STATE,
        isLoadingPage: true,
      };

    case FETCH_AFFILIATE_DASHBOARD.START:
      return { ...state, isLoading: true };

    case FETCH_AFFILIATE_DASHBOARD.SUCCESS: {
      const data = action.payload;

      return {
        ...state,
        dashboardData: data,
        totalAffiliates: data?.totalAffiliates || 0,
        activeAffiliates: data?.activeAffiliates || 0,
        affiliateMetrics: data?.affiliateMetrics || [],
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
        error: null,
      };
    }

    case FETCH_AFFILIATE_DASHBOARD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isPageLevelError: true,
      };
    }

    case FETCH_AFFILIATE_DASHBOARD_DATA.START:
      return { ...state, isPerformanceLoading: true };

    case FETCH_AFFILIATE_DASHBOARD_DATA.SUCCESS:
      return {
        ...state,
        performanceMetrics: action.payload?.affiliates || [],
        performancePaginationInfo: action.payload?.page || null,
        isPerformanceLoading: false,
      };

    case FETCH_AFFILIATE_DASHBOARD_DATA.ERROR:
      return {
        ...state,
        isPerformanceLoading: false,
        performanceMetrics: [],
        performancePaginationInfo: null,
      };

    case FETCH_AFFILIATE_DASHBOARD_SIX_MONTH.START:
      return { ...state, isSixMonthLoading: true };

    case FETCH_AFFILIATE_DASHBOARD_SIX_MONTH.SUCCESS:
      return {
        ...state,
        sixMonthMetrics: action.payload?.affiliateMetrics || [],
        isSixMonthLoading: false,
      };

    case FETCH_AFFILIATE_DASHBOARD_SIX_MONTH.ERROR:
      return {
        ...state,
        isSixMonthLoading: false,
        sixMonthMetrics: [],
      };

    case FETCH_AFFILIATE_RESERVATIONS.START:
      return {
        ...state,
        isLoadingReservations: {
          ...state.isLoadingReservations,
          [action.payload.affiliateId]: true,
        },
      };

    case FETCH_AFFILIATE_RESERVATIONS.SUCCESS:
      return {
        ...state,
        affiliateReservations: {
          ...state.affiliateReservations,
          [action.payload.affiliateId]: {
            reservations: action.payload.reservations || [],
            paginationInfo: action.payload.page || null,
            affiliateName: action.payload.affiliateName,
          },
        },
        isLoadingReservations: {
          ...state.isLoadingReservations,
          [action.payload.affiliateId]: false,
        },
      };

    case FETCH_AFFILIATE_RESERVATIONS.ERROR:
      return {
        ...state,
        isLoadingReservations: {
          ...state.isLoadingReservations,
          [action.payload.affiliateId]: false,
        },
      };

    case TOAST.RESET:
      return {
        ...state,
      };

    default:
      return state;
  }
};
